export const getAdLabelStyles = (/* theme */) => ({
  adLabelRoot: {
    position: 'absolute',
    backgroundColor: 'white', // palette.white,
    color: 'black', // color: palette.black,
    fontSize: 11,
    borderRadius: 5,
    padding: '1.2px 6px 1.8px 6px',
    margin: 7,
    opacity: '90%',
  },

  adLabelRefreshedRoot: {
    display: 'inline-block',
    verticalAlign: 'top',
    borderRadius: '4px',
    border: '0.5px solid rgba(26, 26, 26, 0.3)',
    padding: '1px 4px',
    height: 16,
    boxSizing: 'border-box',
    fontFamily: 'Segoe UI',
    fontWeight: 400,
    fontSize: '11px',
    lineHeight: '12px',
    color: 'rgba(43, 43, 43, 0.8)', // color: palette.black,
  },
});
